export default {
  organizationUsers: state => state.organizationUsers,
}
